







































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import EventsBookingDetails from "../events/EventsBookingDetails.vue";

import ContactJson from "../../shared/ContactJson";
import EventJson from "../../shared/EventJson";
import EventBookingJson, { getEventBookingTotalPrice } from "../../shared/EventBookingJson";
import { EventWithBookingsJson } from "../../shared/EventJson";
import { EventWithBookingJson } from "../../shared/EventJson";
import { EventBookingStatus, EventBookingStatusNames } from "../../shared/EventBookingStatus";
import PaymentExportInfoJson from "../../shared/PaymentExportInfoJson";
import { PaymentExportType } from "../../shared/PaymentExportType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";

export default Vue.extend({
  name: "EventsPayments",
  components: {
    Loading,
    EventsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      EventBookingStatus: EventBookingStatus,
      EventBookingStatusNames: EventBookingStatusNames,
      paymentExportEvents: null as EventWithBookingJson[] | null,
      exportedEvents: null as PaymentExportInfoJson[] | null,
      selectedEventId: null as number | null,
      selectedEventBookingId: null as number | null,
      detailsMode: "read",
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    openDetails(item: EventWithBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedEventId = item.ID;
        this.selectedEventBookingId = item.booking.ID;

        this.detailsMode = mode;
        this.toggleDetails();
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadEventsToExport();
      this.loadExportedEvents();
    },

    async loadEventsToExport() {
      this.paymentExportEvents = null;
      if (this.restClient != null) {
        try {
          this.paymentExportEvents = await this.restClient.getEventBookingsReadyForPaymentExport();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadExportedEvents() {
      this.exportedEvents = null;
      if (this.restClient != null) {
        try {
          this.exportedEvents = await this.restClient.getRecentPaymentExports(PaymentExportType.eventBookings);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //export payment data
    async exportPaymentData() {
      this.isExporting = true;

      try {
        var exportInfo = await this.restClient.exportPaymentsForEventBookings();
        if (exportInfo != null) {
          this.downloadPaymentData(exportInfo);
        } else {
          this.isExporting = false;
          alert("Aktuell sind keine Zahlungsdaten zum Export bereit.");
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    async downloadPaymentData(downloadInfo: PaymentExportInfoJson) {
      this.isExporting = true;

      try {
        var data = await this.restClient.downloadPaymentExportFile(downloadInfo);
        if (data != null) {
          let atag = document.createElement("a");
          atag.style.display = "none";
          document.body.appendChild(atag);

          let blob = new Blob([data], { type: "octet/stream" });
          let url = window.URL.createObjectURL(blob);

          atag.href = url;
          atag.download = "payment_" + DateFormatter.formatFilenameDateTime(new Date(downloadInfo.dateTime)) + ".zip";
          atag.click();
          window.URL.revokeObjectURL(url);

          this.isExporting = false;
          this.loadData();
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    getTotalPrice(item: EventBookingJson) {
      return getEventBookingTotalPrice(
        item.selectedPrice,
        [],
        item.participants ? item.participants.length : item.participantCount ? item.participantCount : 0
      );
    },

    getAllParticipantNames(contacts: ContactJson[]) {
      var participants = "";

      for (let i = 0; i < contacts.length; i++) {
        if (i != 0) {
          participants += ", ";
        }
        participants += contacts[i].firstName;
        participants += " ";
        participants += contacts[i].lastName;
      }

      return participants;
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {},
});
